// extracted by mini-css-extract-plugin
export default {"doc_last_updated_cell":"DocLastUpdatedCell_doc_last_updated_cell__68Sxm"};